<template>
    <dialog
        open
        class="absolute"
        aria-labelledby="modal-title"
        aria-modal="true"
        style="z-index: 9000"
    >
        <!--
          Background backdrop, show/hide based on modal state.

          Entering: "ease-out duration-300"
            From: "opacity-0"
            To: "opacity-100"
          Leaving: "ease-in duration-200"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <div
            class="fixed inset-0 bg-gray-500/50 backdrop-blur-sm transition-opacity"
        ></div>

        <!-- transparent notch -->
        <!--
        <div
            class="fixed bg-white/50 inset-x-0 top-0 backdrop-blur-sm"
            style="height: env(safe-area-inset-top); z-index: 9001"
        >

        </div>
        -->

        <div
            class="fixed inset-0 z-10 w-screen overflow-y-auto"
            @keyup.esc="$emit('close')"
            @mousedown.self="closeStart()"
            @click.self="closeWithGuard"
        >
            <div
                class="mx-auto flex-col flex"
                :class="{ 'lg:w-1/2 mx-4': !large, 'mx-8': large }"
            >
                <div class="my-16 mx-2 sm:mx-4">
                    <div
                        class="rounded-t-lg bg-white text-black items-baseline flex justify-between p-2 sm:p-4"
                    >
                        <div class="font-bold">
                            <slot name="header"></slot>
                        </div>

                        <div class="pt-2 pr-2 sm:block sm:pt-4 sm:pr-4">
                            <button
                                @click="$emit('close')"
                                type="button"
                                class="text-gray-400 hover:text-gray-500 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150"
                                aria-label="Close"
                            >
                                <svg
                                    class="h-6 w-6"
                                    stroke="currentColor"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="M6 18L18 6M6 6l12 12"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div
                        class="rounded-b-lg bg-white p-2"
                        :class="{ 'lg:p-8': !large, 'rounded-b-lg': !hasActionSlot }"
                    >
                        <slot></slot>

                        <div class="rounded-b-lg bg-white" :class="{'lg:p-8': !large}" v-if="hasActionSlot">
                            <div class="mt-8 flex justify-end">
                                <slot name="action"></slot>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </dialog>
</template>

<script>
export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Modal',

    props: {
        large: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        outsideClick: false,
    }),

    methods: {
        closeStart() {
            this.outsideClick = true;
        },
        closeWithGuard() {
            if (this.outsideClick) {
                this.$emit('close');
            }
        },
    },

    computed: {
        hasActionSlot() {
            return !!this.$slots['action'];
        },
    },

};
</script>
